import { Flex, Heading3, PrimaryButton } from "@nulogy/components";
import paths from "config/routePaths";
import React from "react";

export default function AvailabilityEmptyState() {
  return (
    <Flex
      alignItems="center"
      data-testid="empty-availabilities"
      flexDirection="column"
      justifyContent="center"
      marginTop="x6"
    >
      <img alt="empty box" height="180px" src="./svg/components/pages/availability/empty-box.svg" width="240px" />
      <Heading3>Shifts and/or lines have not been set up yet.</Heading3>
      <Flex alignItems="center" justifyContent="center" marginTop="x2">
        <PrimaryButton asLink href={paths.shifts} marginRight="x1" size="medium">
          Create shift
        </PrimaryButton>
        <PrimaryButton asLink href={paths.lines} marginLeft="x1" size="medium">
          Create line
        </PrimaryButton>
      </Flex>
    </Flex>
  );
}
